/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Web_Card3_SubInputs */

const tr_landing_web_card3_sub = /** @type {(inputs: Landing_Web_Card3_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kendi sanal POS’unuzu ve kendi kargo anlaşmanızı bağlarsınız. Satışınızdan komisyon almıyoruz.`)
};

const en_landing_web_card3_sub = /** @type {(inputs: Landing_Web_Card3_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You connect your own payment provider and your own shipping contract. We take no commission on your sales.`)
};

const de_landing_web_card3_sub = /** @type {(inputs: Landing_Web_Card3_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sie hinterlegen Ihren eigenen Zahlungsanbieter und Ihren eigenen Versandvertrag. Wir nehmen keine Verkaufsprovision.`)
};

const ru_landing_web_card3_sub = /** @type {(inputs: Landing_Web_Card3_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вы подключаете собственный платёжный сервис и собственный договор с доставкой. Комиссию с ваших продаж мы не берём.`)
};

/**
* | output |
* | --- |
* | "You connect your own payment provider and your own shipping contract. We take no commission on your sales." |
*
* @param {Landing_Web_Card3_SubInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_web_card3_sub = /** @type {((inputs?: Landing_Web_Card3_SubInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Web_Card3_SubInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_web_card3_sub(inputs)
	if (locale === "de") return de_landing_web_card3_sub(inputs)
	if (locale === "ru") return ru_landing_web_card3_sub(inputs)
	return tr_landing_web_card3_sub(inputs)
});